/**
 * The shared formatters of the Analytics boards — CLM-81 (D-81-1).
 *
 * `formatCount` is the `.toLocaleString()` the codebase already uses
 * (`IngestPlanner.tsx`), written once. **No money formatter ships**: contract
 * value exists only as the extracted phrase `key_terms ->> 'contract_value'`
 * (D-81-2) — add one here when a parsed value column lands.
 */

const COUNT = new Intl.NumberFormat(undefined);

export function formatCount(n: number): string {
  return COUNT.format(n);
}

/** `share` is 0…1 or `null` (nothing in scope); 0 dp. */
export function formatPercent(share: number | null): string {
  if (share === null) return '—';
  return `${String(Math.round(share * 100))}%`;
}

/** `+N` when positive, `0` at zero — the tile footer's "today" figure. */
export function formatDelta(n: number): string {
  return n > 0 ? `+${formatCount(n)}` : '0';
}

/** Whole hours from the API: `< 1 h`, `N h`, `N d` (whole days, floored) when ≥ 48; `—` when unknown. */
export function formatHours(hours: number | null): string {
  if (hours === null) return '—';
  if (hours < 1) return '< 1 h';
  if (hours >= 48) return `${String(Math.floor(hours / 24))} d`;
  return `${String(hours)} h`;
}
